<template>
  <v-container style="padding: 0px" class="leftbox ">
      <vue-headful
            :title="count_read"
        />
    <v-layout row wrap class="hidden-sm-and-down">
      <v-flex sm12 md12 lg12 xl12>
        <v-container style="padding: 0px !important; height: 94vh;"  class="scrolling-wrapper CSChatThai">
          <v-layout column fluid >
            <v-list three-line style="padding: 0px !important; background-color: #1b232d !important; height: 94vh;">
              <v-list-tile  @click="selectmenu(1)" :class="menu1" style="padding: 0px !important;">
                <v-list-tile-content style="padding: 0px !important;margin-right: 0vw; text-align:center;padding: 0 !important;">
                    <!-- <v-badge color="red" right overlap> -->

                  <v-list-tile-title style="padding: 0px !important;text-align:center;height: 44px;">
                    <!-- <v-icon :class="menu1" style="font-size:30px !important;">
                      person
                    </v-icon> -->
                    <v-badge color="red" right overlap v-if="(num_friendreq + num_groupreq) !== 0">
                      <span slot="badge" v-if="(num_friendreq + num_groupreq) < 100">{{num_friendreq + num_groupreq}}</span>
                      <span slot="badge" v-else>99+</span>
                        <v-icon :class="menu1" style="font-size:30px !important;">person</v-icon>
                    </v-badge>
                    <v-icon v-else :class="menu1" style="font-size:30px !important;margin-top: 11px !important;">person</v-icon>
                  </v-list-tile-title>


                  <v-list-tile-sub-title class=" CSChatThai" style="display: flex; justify-content: center;">
                    <b :class="menu1" style="font-size:12px !important;">
                      {{$t('LeftSide.header.friend')}}
                    </b>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile  @click="selectmenu(2)" :class="menu2">
                <v-list-tile-content style="margin-right: 0vw; text-align:center;">
                  <v-list-tile-title  style="text-align:center;height: 30px;">
                    <v-icon  style="font-size:30px !important;" :class="menu2">chat</v-icon>
                  </v-list-tile-title>
                  <v-list-tile-sub-title class=" CSChatThai" style="display: flex; justify-content: center;">
                    <b :class="menu2" style="font-size:12px !important;">
                      {{$t('LeftSide.header.chat')}}
                    </b>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile  @click="selectmenu(3)" :class="menu3">
                <v-list-tile-content style="margin-right: 0vw; text-align:center;">
                  <v-list-tile-title  style="text-align:center;height: 30px;">
                    <v-icon  style="font-size:30px !important;" :class="menu3">fas fa-calendar-alt</v-icon>
                  </v-list-tile-title>
                  <v-list-tile-sub-title class=" CSChatThai" style="display: flex; justify-content: center;">
                    <b :class="menu3" style="font-size:12px !important;">
                      {{$t('LeftSide.header.calendar')}}
                    </b>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

               <v-list-tile  @click="selectmenu(7)" :class="menu7">
                <v-list-tile-content style="margin-right: 0vw; text-align:center;">
                  <v-list-tile-title  style="text-align:center;height: 30px;">
                    <v-icon  style="font-size:30px !important;" :class="menu7">mdi-package-variant</v-icon>
                  </v-list-tile-title>
                  <v-list-tile-sub-title class=" CSChatThai" style="display: flex; justify-content: center;">
                    <b :class="menu7" style="font-size:12px !important;">
                      {{$t('LeftSide.header.service')}}
                    </b>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="selectmenu(8)" :class="menu8">
               <v-list-tile-content style="margin-right: 0vw; text-align:center;">
                 <v-list-tile-title  style="text-align:center;height: 30px;">
                   <!-- <v-icon  style="font-size:30px !important;" :class="menu8">fas fa-video</v-icon> -->
                   <img src="/static/img/icons/onemeet.png" alt="" style="height: 30px !important;">
                 </v-list-tile-title>
                 <v-list-tile-sub-title class=" CSChatThai" style="display: flex; justify-content: center;">
                   <b :class="menu8" style="font-size:12px !important;">
                     {{$t('LeftSide.header.onemeet')}}
                   </b>
                 </v-list-tile-sub-title>
               </v-list-tile-content>
             </v-list-tile>


              <v-list-tile @click="selectmenu(4)" :class="menu4"  style="bottom: 0px; position: fixed; width: 4%;">
               <v-list-tile-content style="margin-right: 0vw;text-align:center;">
                 <v-list-tile-title style="text-align:center;height: 30px;">
                   <v-icon style="font-size:30px !important;"  :class="menu4">settings</v-icon>
                 </v-list-tile-title>
                 <v-list-tile-sub-title class=" CSChatThai" style="display: flex; justify-content: center;">
                   <b  :class="menu4" style="font-size:12px !important;" >
                     {{$t('LeftSide.header.setting')}}
                   </b>
                 </v-list-tile-sub-title>
               </v-list-tile-content>
             </v-list-tile>

              <v-list-tile @click="selectmenu(5)" :class="menu5" v-if="typeuser=='business'">
                <v-list-tile-content style="margin-right: 0vw;text-align:center;">
                  <v-list-tile-title style="text-align:center;height: 30px;">
                    <v-icon style="font-size:30px !important;"  :class="menu5">info</v-icon>
                  </v-list-tile-title>
                  <v-list-tile-sub-title class=" CSChatThai" style="display: flex; justify-content: center;">
                    <b  :class="menu5" style="font-size:12px !important;" >
                      API
                    </b>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="selectmenu(6)" :class="menu6" v-if="typeuser=='business'">
                <v-list-tile-content style="margin-right: 0vw;text-align:center;">
                  <v-list-tile-title style="text-align:center;height: 30px;">
                    <v-icon style="font-size:30px !important;"  :class="menu6">settings_input_antenna</v-icon>
                  </v-list-tile-title>
                  <v-list-tile-sub-title class=" CSChatThai" style="display: flex; justify-content: center;">
                    <b  :class="menu6" style="font-size:12px !important;" >
                      Broadcast
                    </b>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-layout>
        </v-container>
      </v-flex>
      <!-- <v-flex sm10 md10 lg10 xl10>
        <v-tabs fixed-tabs centered v-model="active" class="layoutsearchweb" style=""  slot="extension">
          <v-tab :key="1" href='#tab-1' style="display: none !important;"></v-tab>
          <v-tab :key="2" href='#tab-2' style="display: none !important;"></v-tab>
          <v-tab :key="3" href='#tab-3' style="display: none !important;"></v-tab>
          <v-tab :key="4" href='#tab-4' style="display: none !important;"></v-tab>
          <v-tab :key="7" href='#tab-7' style="display: none !important;"></v-tab>
          <v-tab :key="8" href='#tab-8' style="display: none !important;"></v-tab>
          <v-tabs-items>
            <v-tab-item id="tab-1">
              <v-list dense style="padding-top: 0px;" class="layoutsearchweb">
                <v-container class="layoutsearchweb"
                  >
                  <v-layout row wrap  class="layoutsearchweb">
                    <v-flex xl12 md12 sm12 lg12>
                      <v-text-field append-icon="search" :label="$t('LeftSide.searching')" solo clearable v-model="search"  class="bgsearchweb CSChatThai" style="color: white !important;"></v-text-field>
                    </v-flex>
                    <v-flex xl12 md12 sm12 lg12 style="max-height: 80vh;" class="scrolling-wrapper">
                      <v-expansion-panel >
                        <v-expansion-panel-content  class="expansion_container">
                          <b slot="header" class="CSChatThai" v-if="GroupReq.length != 0">{{$t('LeftSide.friend.groupInvite')}} ({{GroupReq.length}})</b>
                          <v-list two-line subheader style="padding-left: 0px; padding-right: 0px; background-color: #1b232d !important; width: 100%; cursor: pointer;" v-if="GroupReq.length != 0" v-for="(item, index) in GroupReq">
                              <div avatar   style="padding-top: 0px;" >
                                <v-list-tile  avatar  >
                                  <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;" @click="showUserInGroup(item)">
                                    <img v-if="item.picture" :src="item.picture" class="alligator-turtle" >
                                    <img v-else src='/static/img/default_profile/group-white.png' class="alligator-turtle">
                                  </v-list-tile-avatar>
                                  <v-list-tile-content style="margin-right: 0vw;">
                                    <v-list-tile-title class="fontselect " style="font-size:13px;" @click="showUserInGroup(item)">
                                      {{item.name}}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title class="fontselectchat " @click="showUserInGroup(item)">
                                      <span class='fontselectchat '  style="font-size: 11px!important;">
                                        {{$t('LeftSide.friend.haveMember', {count: lengthactive(item.member)})}}
                                      </span>
                                    </v-list-tile-sub-title>
                                    <v-list-tile-sub-title class="CSChatThai">
                                      <v-btn depressed small  class="btnallow" @click="AcceptReq_GroupReq(item)">
                                          {{$t('AnswerQuestion.joinGroup')}}
                                        </v-btn>
                                      <v-btn depressed small class="btncancel" @click="RemoveReq_GroupReq(item)">
                                          {{$t('AnswerQuestion.cancel')}}
                                        </v-btn>
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </div>
                              <v-divider ></v-divider>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel >
                        <v-expansion-panel-content class="expansion_container" >
                          <b slot="header" class="CSChatThai" v-if="FriendSendReq.length != 0">{{$t('LeftSide.friend.sendFriendInvite')}} ({{FriendSendReq.length}})</b>
                          <v-list two-line subheader style="padding-left: 0px; padding-right: 0px; background-color: #1b232d !important; width: 100%;" v-if="FriendSendReq.length != 0">
                            <template v-for="(item, index) in FriendSendReq" >
                              <div avatar style="padding-top: 0px;">
                                <v-list-tile  avatar  >
                                  <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                                    <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle" >
                                    <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                                    <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                                    <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                                  </v-list-tile-avatar>
                                  <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                                    <v-list-tile-title class="fontselect " style="font-size:13px;">
                                      {{item.name}}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title class="fontselectchat ">
                                      <span class='fontselectchat '  style="font-size: 11px!important;">
                                        {{$t('LeftSide.friend.waitingRequestFriend')}}
                                      </span>
                                    </v-list-tile-sub-title>
                                    <v-list-tile-sub-title class="CSChatThai">
                                      <v-btn depressed small class="btncancel" @click="RemoveReq_FriendSendReq(item)">
                                         {{$t('AnswerQuestion.cancel')}}
                                      </v-btn>
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </div>
                              <v-divider ></v-divider>
                            </template>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel >
                        <v-expansion-panel-content class="expansion_container" >
                          <b slot="header" class="CSChatThai" v-if="FriendReq.length != 0">{{$t('LeftSide.friend.friendInvite')}} ({{FriendReq.length}})</b>
                          <v-list two-line subheader style="padding-left: 0px; padding-right: 0px; background-color: #1b232d !important; width: 100%;" v-if="FriendReq.length != 0">
                            <template v-for="(item, index) in FriendReq" >
                              <div avatar  style="padding-top:0px;">
                                <v-list-tile  avatar >
                                  <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                                    <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle" >
                                    <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                                    <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                                    <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                                  </v-list-tile-avatar>
                                  <v-list-tile-content style="margin-right: 0vw;">
                                    <v-list-tile-title class="fontselect " style="font-size:15px;">
                                      {{item.name}}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title class="fontselectchat ">
                                      <span class='fontselectchat '  style="font-size: 11px!important;">
                                        {{$t('LeftSide.friend.wantToBeFriend')}}
                                      </span>
                                    </v-list-tile-sub-title>
                                    <v-list-tile-sub-title class="CSChatThai">
                                      <v-btn depressed small class="btnallow" @click="AcceptReq_FriendReq(item)">
                                        {{$t('AnswerQuestion.acceptFriend')}}
                                      </v-btn>
                                      <v-btn depressed small class="btncancel" @click="RemoveReq_FriendReq(item)">
                                         {{$t('AnswerQuestion.cancel')}}
                                      </v-btn>
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </div>
                              <v-divider ></v-divider>
                            </template>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel >
                        <v-expansion-panel-content class="expansion_container" >
                          <b slot="header" class="CSChatThai" v-if="FilterFriendList.length != 0">{{$t('LeftSide.friend.friend')}} ({{FilterFriendList.length}})</b>
                          <b slot="header" class="CSChatThai" v-else> {{$t('LeftSide.friend.friend')}}</b>
                          <v-list subheader style="padding-left: 0px; padding-right: 0px; background-color: #1b232d !important; width: 100%;" v-if="!Progress.ListFriend">
                            <v-list-tile @click="showDialog('AddFriend')">
                              <v-list-tile-content>
                                <v-list-tile-title class="CSChatThai " style="font-size:12px;text-align:center;color: white;">
                                  <v-icon style="color: white;  font-size: 18px !important;">add_circle</v-icon>
                                  {{$t('LeftSide.friend.addFriend')}}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <template v-for="(item, index) in FilterFriendList" v-if="FilterFriendList.length != 0">
                              <div avatar  @click="routeChat(item)" style="padding-top: 0px;cursor: pointer;">
                                <v-list-tile avatar class="selectF" v-if="actionF == item.tokenroom">
                                  <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                                    <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle" >
                                    <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                                    <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                                    <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                                  </v-list-tile-avatar>
                                  <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                                    <v-list-tile-title class="fontselect " style="font-size:13px;">
                                      {{item.name}}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title class="fontselectchat">
                                      <span class='fontselectchat' v-if="item.status !== ''" style="font-size: 11px!important;">
                                        {{item.status}}
                                      </span>
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                  <v-list-tile-action>
                                <p style="margin-right: 2vw;" v-if="item.type === 'bot'">
                                  <v-badge color="transparent" >
                                    <span slot="badge">
                                      <v-icon style="font-size: 14px;color:white;">fas fa-robot</v-icon>
                                    </span>
                                  </v-badge>
                                </p>
                              </v-list-tile-action>

                                </v-list-tile>
                                <v-list-tile avatar v-else class="nonselectF">
                                  <v-list-tile-avatar  style="padding-left: 1vw; margin-right: 1vw;">
                                    <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle" >
                                    <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                                    <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                                    <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                                  </v-list-tile-avatar>
                                  <v-list-tile-content>
                                    <v-list-tile-title style="font-size:13px;color: white !important;">
                                      {{item.name}}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title >
                                      <span class='text--primary  ' v-if="item.status !== ''" style="color: #7a7a7a !important; font-size: 10px!important;">
                                        {{item.status}}
                                      </span>
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                 <v-list-tile-action>
                                <p style="margin-right: 2vw;" v-if="item.type === 'bot'">
                                  <v-badge color="transparent" >
                                    <span slot="badge">
                                      <v-icon style="font-size: 14px;">fas fa-robot</v-icon>
                                    </span>
                                  </v-badge>
                                </p>
                              </v-list-tile-action>
                                </v-list-tile>
                              </div>
                              <v-divider ></v-divider>
                            </template>
                          </v-list>
                          <div v-else>
                            <v-progress-linear :indeterminate="Progress.ListFriend"></v-progress-linear>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                      <v-expansion-panel >
                        <v-expansion-panel-content  class="expansion_container" >
                          <b slot="header" class="CSChatThai" v-if="FilterGroupList.length != 0">{{$t('LeftSide.friend.group')}} ({{FilterGroupList.length}})</b>
                          <b slot="header" class="CSChatThai" v-else>{{$t('LeftSide.friend.group')}}</b>
                          <div subheader v-if="!Progress.ListFriend">
                            <v-list subheader style="padding-left: 0px; padding-right: 0px; background-color: #1b232d !important; width: 100%;cursor: pointer;" >

                              <v-list-tile @click="showDialog('CreateGroup')">
                                <v-list-tile-content>
                                  <v-list-tile-title class="CSChatThai " style="font-size:12px;text-align:center;color: white;">
                                    <v-icon style="color: white;  font-size: 18px !important;">add_circle</v-icon>
                                    {{$t('LeftSide.friend.createGroup')}}
                                  </v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>

                              <template v-for="(item, index) in FilterGroupList" v-if="FilterGroupList.length != 0">
                                <div avatar   @click="routeChat(item)" style="padding-top: 0px;">
                                  <v-list-tile  avatar  class="selectF" v-if="actionF == item.tokenroom">
                                    <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                                      <img v-if="item.picture" :src="item.picture" class="alligator-turtle" >
                                      <img v-else src='/static/img/default_profile/group-white.png' class="alligator-turtle">
                                    </v-list-tile-avatar>

                                    <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                                      <v-list-tile-title class="fontselect " style="font-size:13px;">
                                        {{item.name}}
                                      </v-list-tile-title>

                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-list-tile avatar v-else class="nonselectF">
                                    <v-list-tile-avatar  style="padding-left: 1vw; margin-right: 1vw;">
                                      <img v-if="item.picture" :src="item.picture" class="alligator-turtle">
                                      <img v-else src='/static/img/default_profile/group-white.png' class="alligator-turtle">
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title style="font-size:13px;color: white !important;">
                                        {{item.name}}
                                      </v-list-tile-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </div>
                                <v-divider ></v-divider>
                              </template>
                            </v-list>
                          </div>
                          <div v-else>
                            <v-progress-linear :indeterminate="Progress.ListGroup"></v-progress-linear>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list>
            </v-tab-item>

            <v-tab-item  id="tab-2" >
              <v-list dense style="padding-top: 0px !important;" class="layoutsearchweb">
                <vue-context ref="menu" style="z-index: 1500;">
                   <li v-for="list in ListMenuRightClick">
                     <a @click="SelectMenuRightClick(list.methods)">{{list.message}}</a>
                   </li>
                </vue-context>
                <v-container class="layoutsearchweb">
                  <v-layout row wrap  class="layoutsearchweb">
                    <v-flex xl12 md12 sm12 lg12>
                      <v-text-field  append-icon="search" :label="$t('LeftSide.searching')" solo clearable v-model="search"  class="bgsearchweb CSChatThai"></v-text-field>
                    </v-flex>
                    <v-flex xl12 md12 sm12 lg12 style="max-height: 80vh;" class="scrolling-wrapper" v-if="!Progress.ListChat">
                      <v-list two-line subheader style="padding-left: 0px !important; padding-right: 0px; background-color: #1b232d !important; width: 100%; cursor: pointer;">
                        <template v-for="(item, index) in FilterChatList" v-if="FilterChatList.length != 0">
                          <div avatar   @click="routeChat(item)" style="padding-top: 0px;" v-if="item.is_active == 'true'">
                            <v-list-tile  avatar  class="selectF" v-if="actionF == item.tokenroom" @contextmenu.prevent="RightClickDialog($event, ['pinchat'], item)">
                              <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                                <img v-if="item.picture" :src="item.picture" class="alligator-turtle" >
                                <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                                <img v-else-if="item.type === 'group'" src='/static/img/default_profile/group-white.png' class="alligator-turtle">
                                <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                                <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                                <v-badge color="primary" v-if="item.pin == 'true'">
                                  <img slot="badge" src="/static/img/icons/pin@3x.png" alt="" class="img-pin">
                                </v-badge>
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title class="fontselect" >
                                  {{item.name}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title class="fontselectchat">
                                  <span class='fontselectchat' v-if="item.state !== 'friend' && item.state !== 'active' && item.state !== 'group' && item.state !== 'user'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.leftChat')}}
                                  </span>
                                  <span
                                    class='fontselectchat' v-else-if="item.typeofmessage === 'message'"
                                    style="font-size: 11px!important;"
                                    v-html="convertMention(item.message)"
                                  >
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'sticker'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendSticker')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'file'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendFile')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'location'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendLocation')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'contact'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendContact')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'image'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendPicture')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'note'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendNote')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'video'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendVideo')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'mention_message'" style="font-size: 11px!important;">
                                    {{item.message}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'albums_message'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.createAlbum')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'task_message'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.createTask')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'system_action_task'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.createProject')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'approve_message'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.approveMessage')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'unsend_message'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.unsendMessage')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'official_template'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendOfficial_template')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'conference_msg'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendConference_msg')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'carousel'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendCarousel')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'system' || item.typeofmessage === 'template' || item.typeofmessage === 'date' || item.typeofmessage === 'datetime'" style="font-size: 11px!important;">
                                    {{item.message}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'call'" style="font-size: 11px!important;">
                                    <div v-if="item.message === 'success'">
                                      <v-icon style="font-size: 13px; color: white; margin-right: 5px;">fas fa-phone fa-rotate-90</v-icon> {{$t('LeftSide.chat.call.time')}} {{secondsToHms(item.time_count)}}
                                    </div>
                                    <div v-else-if="item.message === 'decline' && item.tokenuser === token"><v-icon style="font-size: 13px; color: white; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.noResponse')}}
                                    </div>
                                    <div v-else-if="item.message === 'decline' && item.tokenuser !== token"><v-icon style="font-size: 13px; color: white; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                                    </div>
                                    <div v-else-if="item.message === 'cancle' && item.tokenuser === token"><v-icon style="font-size: 13px; color: white; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                                    </div>
                                    <div v-else-if="item.message === 'cancle' && item.tokenuser !== token"><v-icon style="font-size: 13px; color: white; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.missed')}}
                                    </div>
                                    <div v-else-if="item.message === 'cancel' && item.tokenuser === token"><v-icon style="font-size: 13px; color: white; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                                    </div>
                                    <div v-else-if="item.message === 'cancel' && item.tokenuser !== token"><v-icon style="font-size: 13px; color: white; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.missed')}}
                                    </div>
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'system_action'" style="font-size: 11px!important;">
                                    <div v-if="item.message === 'invite'">
                                      {{item.nickname}} เชิญ {{item.file_name}}
                                    </div>
                                    <div v-else-if="item.message === 'kick'">
                                      {{item.nickname}} ลบ {{item.file_name}} ออกจากกลุ่ม
                                    </div>
                                    <div v-else-if="item.message === 'leave' && item.tokenuser === token">
                                      คุณออกจากกลุ่ม
                                    </div>
                                    <div v-else-if="item.message === 'leave' && item.tokenuser !== token">
                                      {{item.nickname}} ออกจากกลุ่ม
                                    </div>
                                    <div v-else-if="item.message === 'active' && item.tokenuser === token">
                                      คุณเข้าร่วมกลุ่ม
                                    </div>
                                    <div v-else-if="item.message === 'active' && item.tokenuser !== token">
                                      {{item.nickname}} เข้าร่วมกลุ่ม
                                    </div>
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user' && item.typeofmessage !== 'message'" style="font-size: 11px !important;">
                                    {{$t('LeftSide.chat.startChat')}}
                                  </span>
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <p style="margin-right: 0.5vw; color: #bdbdbd !important; font-size: 11px;" v-if="item.timestamp != ''&& (item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user')">
                                  {{time(item.timestamp)}}
                                </p>
                                <p style="margin-right: 2vw;" v-if="item.state == 'friend' || item.state == 'active' || item.state == 'group' || item.state == 'user'">
                                  <v-badge color="red" >
                                    <span slot="badge" class="Kanit" style="font-size: 12px;" v-if="parseInt(item.count_read) >= 1000">999+</span>
                                    <span v-else-if="item.count_read != '' && parseInt(item.count_read) != 0 && item.message != ''" slot="badge" style="font-size: 11px; text-align: center;" class="Kanit" >{{item.count_read}}</span>
                                  </v-badge>
                                </p>
                              </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile avatar class="nonselectF" v-else @contextmenu.prevent="RightClickDialog($event, ['pinchat'], item)">
                              <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                                <img v-if="item.picture" :src="item.picture" class="alligator-turtle" >
                                <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                                <img v-else-if="item.type === 'group'" src='/static/img/default_profile/group-white.png' class="alligator-turtle">
                                <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                                <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                                <v-badge color="primary" v-if="item.pin == 'true'">
                                  <img slot="badge" src="/static/img/icons/pin@3x.png" alt="" class="img-pin">
                                </v-badge>
                              </v-list-tile-avatar>
                              <v-list-tile-content >
                                <v-list-tile-title class="nonfontselect">
                                  {{item.name}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title class="fontselectchat">
                                  <span class='fontselectchat' v-if="item.state !== 'friend' && item.state !== 'active' && item.state !== 'group' && item.state !== 'user'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.leftChat')}}
                                  </span>
                                  <span class='fontselectchat'
                                    v-else-if="item.typeofmessage === 'message'"
                                    style="font-size: 11px!important;"
                                    v-html="convertMention(item.message)"
                                  >
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'sticker'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendSticker')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'file'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendFile')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'location'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendLocation')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'contact'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendContact')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'image'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendPicture')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'note'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendNote')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'video'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendVideo')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'mention_message'" style="font-size: 11px!important;">
                                    {{item.message}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'albums_message'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.createAlbum')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'task_message'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.createTask')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'system_action_task'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.createProject')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'approve_message'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.approveMessage')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'unsend_message'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.unsendMessage')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'official_template'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendOfficial_template')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'conference_msg'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendConference_msg')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'carousel'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.sendCarousel')}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'system' || item.typeofmessage === 'template' || item.typeofmessage === 'date' || item.typeofmessage === 'datetime'" style="font-size: 11px!important;">
                                    {{item.message}}
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'call'" style="font-size: 11px!important;">
                                    <div v-if="item.message === 'success'">
                                      <v-icon style="font-size: 13px; color: white; margin-right: 5px;">fas fa-phone fa-rotate-90</v-icon> {{$t('LeftSide.chat.call.time')}} {{secondsToHms(item.time_count)}}
                                    </div>
                                    <div v-else-if="item.message === 'decline' && item.tokenuser === token"><v-icon style="font-size: 13px; color: white; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.noResponse')}}
                                    </div>
                                    <div v-else-if="item.message === 'decline' && item.tokenuser !== token"><v-icon style="font-size: 13px; color: white; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                                    </div>
                                    <div v-else-if="item.message === 'cancle' && item.tokenuser === token"><v-icon style="font-size: 13px; color: white; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                                    </div>
                                    <div v-else-if="item.message === 'cancle' && item.tokenuser !== token"><v-icon style="font-size: 13px; color: white; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.missed')}}
                                    </div>
                                    <div v-else-if="item.message === 'cancel' && item.tokenuser === token"><v-icon style="font-size: 13px; color: white; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                                    </div>
                                    <div v-else-if="item.message === 'cancel' && item.tokenuser !== token"><v-icon style="font-size: 13px; color: white; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.missed')}}
                                    </div>
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.typeofmessage === 'system_action'" style="font-size: 11px!important;">
                                    <div v-if="item.message === 'invite'">
                                      {{item.nickname}} เชิญ {{item.file_name}}
                                    </div>
                                    <div v-else-if="item.message === 'kick'">
                                      {{item.nickname}} ลบ {{item.file_name}} ออกจากกลุ่ม
                                    </div>
                                    <div v-else-if="item.message === 'leave' && item.tokenuser === token">
                                      คุณอกจากกลุ่ม
                                    </div>
                                    <div v-else-if="item.message === 'leave' && item.tokenuser !== token">
                                      {{item.nickname}} ออกจากกลุ่ม
                                    </div>
                                    <div v-else-if="item.message === 'active' && item.tokenuser === token">
                                      คุณเข้าร่วมกลุ่ม
                                    </div>
                                    <div v-else-if="item.message === 'active' && item.tokenuser !== token">
                                      {{item.nickname}} เข้าร่วมกลุ่ม
                                    </div>
                                  </span>
                                  <span class='fontselectchat' v-else-if="item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user' && item.typeofmessage !== 'message'" style="font-size: 11px!important;">
                                    {{$t('LeftSide.chat.startChat')}}
                                  </span>
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <p style="margin-right: 0.5vw; color: #bdbdbd !important; font-size: 11px;" v-if="item.timestamp != '' && (item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user')">
                                  {{time(item.timestamp)}}
                                </p>
                                <p style="margin-right: 2vw;" v-if="item.state == 'friend' || item.state == 'active' || item.state == 'group' || item.state == 'user'">
                                  <v-badge color="red" >
                                    <span slot="badge" class="Kanit" style="font-size: 12px;" v-if="parseInt(item.count_read) >= 1000">999+</span>
                                    <span v-else-if="item.count_read != '' && parseInt(item.count_read) != 0 && item.message != ''" slot="badge" style="font-size: 11px; text-align: center;" class="Kanit" >{{item.count_read}}</span>
                                  </v-badge>
                                </p>
                              </v-list-tile-action>
                            </v-list-tile>
                          </div>
                          <v-divider v-if="item.is_active == 'true'" ></v-divider>
                        </template>
                      </v-list>
                    </v-flex>
                    <v-flex xl12 md12 sm12 lg12 style="max-height: 80vh;" class="scrolling-wrapper" v-else>
                       <v-progress-linear :indeterminate="Progress.ListChat"></v-progress-linear>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list>
            </v-tab-item>

            <v-tab-item  id="tab-3" class="layoutsearchweb">
              <v-list dense style="padding-top: 0px !important;" class="layoutsearchweb">
                <v-container class="layoutsearchweb">
                  <v-layout row wrap  class="layoutsearchweb">
                    <v-flex xl12 md12 sm12 lg12 style="max-height: 80vh;" class="scrolling-wrapper">
                      <v-list subheader style="padding-left: 0px !important; padding-right: 0px; background-color: #1b232d !important; width: 100%;" v-if="typeuser != 'business'">
                        <template v-for="(item, index) in listmenutask" >
                          <div avatar style="padding-top: 0px;">
                            <v-list-tile  avatar @click="changepathproject(item.path)" class="selectF" v-if="$router.currentRoute.path == '/chat/project/'+ item.path || pathsettings == '/chat/project/'+ item.path">
                              <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                                <v-icon style="color:#53CEFF !important;"> {{item.icon}}</v-icon>

                              </v-list-tile-avatar>
                              <v-list-tile-content >
                                <v-list-tile-title class="fontselect" >
                                  {{item.title}}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                             <v-list-tile  avatar @click="changepathproject(item.path)" class="nonselectF" v-else>
                              <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                                <v-icon style="color: #d1d1d1 !important;"> {{item.icon}}</v-icon>
                              </v-list-tile-avatar>
                              <v-list-tile-content >
                                <v-list-tile-title class="nonfontselect" style="color: #d1d1d1 !important;">
                                 {{item.title}}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </div>
                          <v-divider ></v-divider>
                        </template>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list>
            </v-tab-item>


            <v-tab-item id="tab-4" class="layoutsearchweb">
              <v-list dense style="padding-top: 0px !important;" class="layoutsearchweb">
                <v-container class="layoutsearchweb">
                  <v-layout row wrap  class="layoutsearchweb">
                    <v-flex xl12 md12 sm12 lg12 style="max-height: 80vh;" class="scrolling-wrapper">
                      <v-list subheader style="padding-left: 0px !important; padding-right: 0px; background-color: #1b232d !important; width: 100%;" v-if="typeuser != 'business'">
                        <template v-for="(item, index) in listmenu" >
                          <div avatar style="padding-top: 0px;">
                            <v-list-tile  avatar @click="changepathsettings(item.path)" class="selectF" v-if="$router.currentRoute.path == '/chat/settings/'+ item.path || pathsettings == '/chat/settings/'+ item.path">
                              <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                                <v-icon style="color:#53CEFF !important;"> {{item.icon}}</v-icon>

                              </v-list-tile-avatar>
                              <v-list-tile-content >
                                <v-list-tile-title class="fontselect" >
                                  {{item.title}}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                             <v-list-tile  avatar @click="changepathsettings(item.path)" class="nonselectF" v-else>
                              <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                                <v-icon style="color: #d1d1d1 !important;"> {{item.icon}}</v-icon>
                              </v-list-tile-avatar>
                              <v-list-tile-content >
                                <v-list-tile-title class="nonfontselect" style="color: #d1d1d1 !important;">
                                 {{item.title}}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </div>
                          <v-divider ></v-divider>
                        </template>
                      </v-list>

                      <v-list subheader style="padding-left: 0px !important; padding-right: 0px; background-color: #1b232d !important; width: 100%;" v-else>
                        <template v-for="(item, index) in listmenusettingapi" >
                          <div avatar style="padding-top: 0px;">
                            <v-list-tile  avatar @click="changepathsettings(item.path)">
                              <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                                <v-icon style="color: white;"> {{item.icon}}</v-icon>

                              </v-list-tile-avatar>
                              <v-list-tile-content >
                                <v-list-tile-title class="fontselect" >
                                  {{item.title}}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </div>
                          <v-divider ></v-divider>
                        </template>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list>
            </v-tab-item>

            <v-tab-item  id="tab-5" class="layoutsearchweb">

              <v-list dense style="padding-top: 0px !important;" class="layoutsearchweb">
                <v-container class="layoutsearchweb">
                  <v-layout row wrap  class="layoutsearchweb">
                    <v-flex xl12 md12 sm12 lg12 style="max-height: 80vh;" class="scrolling-wrapper">
                      <v-list subheader style="padding-left: 0px !important; padding-right: 0px; background-color: #1b232d !important; width: 100%;" >
                        <template v-for="(item, index) in listmenuapi" >
                          <div avatar style="padding-top: 0px;">
                            <v-list-tile  avatar @click="changepathapi(item.path)">
                              <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                                <v-icon style="color: white;"> {{item.icon}}</v-icon>

                              </v-list-tile-avatar>
                              <v-list-tile-content >
                                <v-list-tile-title class="fontselect" >
                                  {{item.title}}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </div>
                          <v-divider ></v-divider>
                        </template>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list>
            </v-tab-item>

            <v-tab-item  id="tab-6" class="layoutsearchweb">

              <v-list dense style="padding-top: 0px !important;" class="layoutsearchweb">
                <v-container class="layoutsearchweb">
                  <v-layout row wrap  class="layoutsearchweb">
                    <v-flex xl12 md12 sm12 lg12 style="max-height: 80vh;" class="scrolling-wrapper">
                      <v-list subheader style="padding-left: 0px !important; padding-right: 0px; background-color: #1b232d !important; width: 100%;" >
                        <template v-for="(item, index) in listmenubroadcast" >
                          <div avatar style="padding-top: 0px;">
                            <v-list-tile  avatar @click="changebroadcast(item.path)">
                              <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                                <v-icon style="color: white;"> {{item.icon}}</v-icon>

                              </v-list-tile-avatar>
                              <v-list-tile-content >
                                <v-list-tile-title class="fontselect" >
                                  {{item.title}}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </div>
                          <v-divider ></v-divider>
                        </template>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list>
            </v-tab-item>


             <v-tab-item id="tab-7" class="layoutsearchweb">
              <v-list dense style="padding-top: 0px !important;" class="layoutsearchweb">
                <v-container class="layoutsearchweb">
                  <v-layout row wrap  class="layoutsearchweb">
                    <v-flex xl12 md12 sm12 lg12 style="max-height: 80vh;" class="scrolling-wrapper">
                      <v-list subheader style="padding-left: 0px !important; padding-right: 0px; background-color: #1b232d !important; width: 100%;">
                        <template v-for="(item, index) in listmenuService" >
                          <div avatar style="padding-top: 0px;">
                            <v-list-tile  avatar @click="changepathservice(item.path, item.type)" :class="$router.currentRoute.path ==  item.path? 'selectF':'nonselectF'" >
                              <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                                <img :src="item.icon"/>
                              </v-list-tile-avatar>
                              <v-list-tile-content >
                                <v-list-tile-title class="nonfontselect" >
                                  {{item.title}}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </div>
                          <v-divider ></v-divider>
                        </template>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list>
            </v-tab-item>

            <v-tab-item id="tab-8" class="layoutsearchweb">
             <v-list dense style="padding-top: 0px !important;" class="layoutsearchweb">
               <v-container class="layoutsearchweb">
                 <v-layout row wrap  class="layoutsearchweb">
                   <v-flex xl12 md12 sm12 lg12 style="max-height: 80vh;" class="scrolling-wrapper">
                     <v-list subheader style="padding-left: 0px !important; padding-right: 0px; background-color: #1b232d !important; width: 100%;">
                       <template v-for="(item, index) in listmenuOnemeet">
                         <div avatar style="padding-top: 0px;">
                           <v-list-tile  avatar @click="toPageOnemeet(item.path, item.type)" :class="$router.currentRoute.path ==  item.path? 'selectF':'nonselectF'" >
                             <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                               <img :src="item.icon"/>
                             </v-list-tile-avatar>
                             <v-list-tile-content >
                               <v-list-tile-title class="nonfontselect" >
                                 {{item.title}}
                               </v-list-tile-title>
                             </v-list-tile-content>
                           </v-list-tile>
                         </div>
                         <v-divider ></v-divider>
                       </template>
                     </v-list>
                   </v-flex>
                 </v-layout>
               </v-container>
             </v-list>
           </v-tab-item>
          </v-tabs-items>

        </v-tabs>
        <AddDialog :dialogAdd="AddFriend" @closeDialogAddFriend="closeDialogAddFriend" @updatelistreq="updatelistreq" @blockevent="blockevent"></AddDialog>
        <CreateGroupDialog :dialogGroup="CreateGroup" @closeDialogCreateGroup="closeDialogCreateGroup" @updatecreategroup="updatecreategroup" @updatelistchat="updatelistchat"></CreateGroupDialog>
        <ShowFriendDialog :dialogShowfriend="ShowFriend" @closeDialogShowFriend="closeDialogShowFriend" :showgroup="showgroup"></ShowFriendDialog>
        <CheckBrowserDialog :checkBrowserDialog="checkBrowserDialog" @closeCheckBrowser="closeCheckBrowser" :checkBrowserInfor="checkBrowserInfor"></CheckBrowserDialog>
      </v-flex> -->
    </v-layout>
  </v-container>
</template>

<script>
import AddDialog from '@/components/chat/dialog/manage_friend/AddFriendDialog'
import CreateGroupDialog from '@/components/chat/dialog/manage_group/CreateGroupDialog'
import ShowFriendDialog from '@/components/chat/dialog/manage_group/ShowFriendDialog'
import CheckBrowserDialog from '@/components/chat/dialog/CheckBrowserDialog'
import { sync } from 'vuex-pathify'
import { Momenttime, Decode, Encode } from '@/services'
import { VueContext } from 'vue-context';
import Vue from 'vue'
import vueHeadful from 'vue-headful'

Vue.component('vue-headful', vueHeadful)

var _ = require('lodash')

export default {
  data: () => ({
    // ProgressListChat: false,
    // ProgressListFriend: false,
    // ProgressListGroup: false,
    checkBrowserDialog: false,
    checkBrowserInfor: {},
    SelectedMessageDetail: {},
    ListMenuRightClick: [],
    rightclickdialog: false,
    Progress: {
      ListChat: false,
      ListFriend: false,
      ListGroup: false
    },
    search: '',
    listfriend: [],
    listgroup: [],
    listchat: [],
    tabs: null,
    AddFriend: false,
    ShowFriend: false,
    block: false,
    CreateGroup: false,
    actionF: '',
    token: '',
    listmenusettingapi: [
      {
        title: 'ส่งไฟล์ไป One box',
        icon: 'file_upload',
        path: 'onebox'
      },
      {
        title: 'ข้อเสนอแนะ',
        icon: 'feedback',
        path: 'feedback'
      },
      {
        title: 'ศูนย์ช่วยเหลือ',
        icon: 'contact_support',
        path: 'contact_support'
      },
      {
        title: 'นโยบายความเป็นส่วนตัว',
        icon: 'book',
        path: 'private_policy'
      }
    ],
    listmenutask: [],
    listmenu: [],
    listmenuService: [
      {
        title: 'OneEmail',
        icon: '/static/img/oneplatform/oneemail2.png',
        path: process.env.WEBoneEmail,
        type: 'link'
      },
      {
        title: 'OneBox',
        icon: '/static/img/oneplatform/onebox.png',
        path: process.env.WEBoneBox,
        type: 'share_token_onebox'
      },
      {
        title: 'OneChat News',
        icon: '/static/img/oneplatform/onechat_news.jpg',
        path: process.env.WEBNews,
        type: 'function_news'
      },
      {
        title: 'One Anonymous',
        icon: '/static/img/oneplatform/anonymousone.png',
        path: '/anonymousone_group',
        type: 'route'
      }
      // {
      //   title: 'Market',
      //   icon: '/static/img/oneplatform/market2.png',
      //   path: '/chat/service/market',
      //   type: 'route'
      // }
    ],
    //   {
    //     title: 'แก้ไขโปรไฟล์',
    //     icon: 'person',
    //     path: 'profile'
    //   },
    //   {
    //     title: 'จัดการเพื่อน',
    //     icon: 'fas fa-users',
    //     path: 'managefriend'
    //   },
    //   {
    //     title: 'ส่งไฟล์ไป One box',
    //     icon: 'file_upload',
    //     path: 'uploadfile/onebox'
    //   },
    //   {
    //     title: 'ข้อเสนอแนะ',
    //     icon: 'feedback',
    //     path: 'feedback'
    //   },
    //   {
    //     title: 'ศูนย์ช่วยเหลือ',
    //     icon: 'contact_support',
    //     path: 'support'
    //   },
    //   {
    //     title: 'นโยบายความเป็นส่วนตัว',
    //     icon: 'book',
    //     path: 'policy'
    //   }

    // ],
    listmenubroadcast: [
      {
        title: 'บรอดแคส',
        icon: 'settings_input_antenna',
        path: 'broadcast'
      },
      {
        title: 'ประวัติการบรอดแคส',
        icon: 'view_list',
        path: 'history_broadcast'
      }
    ],
    listmenuapi: [
      {
        title: 'ข้อมูลนักพัฒนา',
        icon: 'person',
        path: 'dev_profile'
      },
      {
        title: 'ข้อมูลห้องแชทเพื่อน',
        icon: 'chat',
        path: 'dev_infofriend'
      },
      {
        title: 'ข้อมูลห้องแชทกลุ่ม',
        icon: 'group',
        path: 'dev_infogroup'
      }
    ],
    listmenuOnemeet: [
      {
        title: 'ข้อมูลนักพัฒนา',
        icon: 'person',
        path: '/onemeet',
        type: 'chatroom'
      },
    ],
    FriendReq: [],
    FriendSendReq: [],
    GroupReq: [],
    active: null,
    menu1: 'nonselect_Menu',
    menu2: 'nonselect_Menu',
    menu3: 'nonselect_Menu',
    menu4: 'nonselect_Menu',
    menu5: 'nonselect_Menu',
    menu6: 'nonselect_Menu',
    menu7: 'nonselect_Menu',
    menu8: 'select_Menu',
    showgroup: false,
    num_friendreq: 0,
    num_groupreq: 0,
    count_read: 'OneChat',
    notread: 0,
    encodeToken_News: '',
    one_id: ''
  }),
  components: {
    AddDialog,
    CreateGroupDialog,
    ShowFriendDialog,
    VueContext,
    CheckBrowserDialog
  },
  created () {
    // var test = {
    //   one_id: 'u77',
    //   ExpiredDate: Momenttime.momentCreateDate()
    // }
    // this.encodeToken_News = Encode.encodeAuthen_news(test)
    // console.log(mama)
    // console.log(Decode.decodeAuthen_news(mama))
    this.active = 'tab-8'
    this.menu8 = 'select_Menu '
    this.changeLangMenu()
    this.removefriend = false
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.typeuser = localStorage.getItem('type_user')
    this.actionF = this.$route.params.roomid
    // console.log(this.actionF)
    if (this.actionF != undefined) {
      var data = {tokenroom: this.actionF}
      this.mark_read(data)
    }
    this.getlistfriend()
    this.getlistgroup()
    this.getlistchat()
    this.getlistpending()
    this.getcount_notread()
    this.getOneid()
    // console.log(Momenttime.momentCreateDate())
  },
  // computed: {
  //   count_read () {
  //     if (this.notread == 0) {
  //       this.count_read = 'Onechat'
  //     } else {
  //       this.count_read = '('+response.data.count_read+') Onechat'
  //     }
  //   }
  // },
  methods: {
    toPageOnemeet (path, type) {
      console.log(path)
      console.log(type)
      this.$router.push(path)
    },
    getlistpending () {
      // this.axios.post(process.env.APImanage + '/web/getlistrequestfriend', {tokenuser: this.token}).then((response) => {
      //   this.FriendReq = response.data['listrequestfriend']
      //   this.num_friendreq = response.data['listrequestfriend'].length
      // })
      // this.axios.post(process.env.APImanage + '/web/getlistpendingfriend', {tokenuser: this.token}).then((response) => {
      //   this.FriendSendReq = response.data['listpendingfriend']
      // })
      // this.axios.post(process.env.APImanage + '/web/getlistpendinggroup', {tokenuser: this.token}).then((response) => {
      //   this.GroupReq = response.data['listpendinggroup']
      //   this.num_groupreq = response.data['listpendinggroup'].length
      // })

      this.axios.post(process.env.APIgo_api + '/v1/get-list-pending', {tokenuser: this.token}).then((response) => {
        this.FriendSendReq = response.data['list_send_request_friend']
        this.FriendReq = response.data['list_request_friend']
        this.GroupReq = response.data['list_pending_group']

        this.num_friendreq = response.data['list_request_friend'].length
        this.num_groupreq = response.data['list_pending_group'].length
      })
    },
    closeCheckBrowser (value) {
      this.checkBrowserDialog = value
      this.checkBrowserInfor = {}
    },
    checkBrowser (url) {
      // console.log(url)
      console.log('check browser')
      // Get the user-agent string
      let userAgentString = navigator.userAgent;
      // Detect Chrome
      let chromeAgent = userAgentString.indexOf("Chrome") > -1;
      // Detect Internet Explorer
      let IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
      // Detect Firefox
      let firefoxAgent = userAgentString.indexOf("Firefox") > -1;
      // Detect Safari
      let safariAgent = userAgentString.indexOf("Safari") > -1;
      // Discard Safari since it also matches Chrome
      let operaAgent = userAgentString.indexOf("OP") > -1;
      // console.log('firefox = > ' + firefoxAgent)
      // console.log('ie = > ' + IExplorerAgent)
      // console.log('chrome = > ' + chromeAgent)
      // console.log('opera = > ' + operaAgent)
      // console.log('safari = > ' + safariAgent)
       if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
          this.checkBrowserInfor = {
            url: url,
            payload: ''
          }
          this.checkBrowserDialog = true
       } else if (safariAgent === true && chromeAgent === true) {
           window.open(url, '_blank')
       } else if (safariAgent === true) {
         this.checkBrowserInfor = {
           url: url,
           payload: ''
         }
         this.checkBrowserDialog = true
      } else {
        window.open(url, '_blank')
      }
    },
    convertMention(msg){
      msg = msg.replace(/\<tax>/g,'<span style="color:#1976d2;">@');
      msg = msg.replace(/<\/tax>/g,'</span>');
      // console.log(msg)
      return msg
    },
    getOneid () {
      this.axios.get(process.env.APIgo_api + '/v1/getOneID/' + this.token).then((response) => {
        // console.log(response.data.one_id)
        this.one_id = response.data.one_id
        // if (response.data.status === 'success') {
        //   // console.log(response.data)
        //   if (response.data.count_read != 0) {
        //     // this.count_read = '('+response.data.count_read+') Onechat'
        //     this.notread = response.data.count_read
        //   } else {
        //     // this.count_read = 'Onechat'
        //     this.notread = 0
        //   }
        // }
      }, () => {
        console.log('error')
      })
    },
    changepathservice (path, type) {
      // console.log('type' + type)

      if (type == 'link') {
        window.open(path)
      } else if (type == 'route') {
        this.$router.push(path)
      } else if (type == 'function_news') {
        // console.log('test')
        // console.log(Momenttime.momenttimestamp())
        var test = {
          one_id: this.one_id,
          createdDate: Momenttime.momentCreateDate()
        }
        this.encodeToken_News = Encode.encodeAuthen_news(test)
        window.open(path + this.encodeToken_News)
        // console.log(window.navigator.geolocation)
        // if (window.navigator.geolocation) {
        //   console.log('oo')
        //   window.navigator.geolocation.getCurrentPosition((position) => {
        //     console.log('rr')
        //     var test = {
        //       one_id: this.one_id,
        //       createdDate: Momenttime.momentCreateDate(),
        //       latitude: position.coords.latitude,
        //       longitude: position.coords.longitude
        //     }
        //     this.encodeToken_News = Encode.encodeAuthen_news(test)
        //     console.log(Decode.decodeAuthen_news(this.encodeToken_News))
        //     window.open(path + this.encodeToken_News)
        //   })
        // } else {
        //   var test = {
        //     one_id: this.one_id,
        //     createdDate: Momenttime.momentCreateDate()
        //   }
        //   this.encodeToken_News = Encode.encodeAuthen_news(test)
        //   console.log(Decode.decodeAuthen_news(this.encodeToken_News))
        //   window.open(path + this.encodeToken_News)
        // }

      } else if ('share_token_onebox') {
        this.axios.post(process.env.APIimage + `/api/v1/get_encode_shared_token`, {
          user_id: this.one_id
        }).then((response) => {
          // console.log(response.data.data.encode_shared_token)
          var url = process.env.WEB_Redirect_Onebox + response.data.data.encode_shared_token
          this.checkBrowser(url)
        })
      }
    },
    getcount_notread () {
      this.axios.post(process.env.APImanage + '/getnotreadcount', {
        tokenuser: this.token
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          if (response.data.count_read != 0) {
            // this.count_read = '('+response.data.count_read+') Onechat'
            this.notread = response.data.count_read
          } else {
            // this.count_read = 'Onechat'
            this.notread = 0
          }
        }
      }, () => {
        console.log('error')
      })
    },
    RightClickDialog ($event, list, item) {
      // console.log(list)
      // console.log(item)
      this.ListMenuRightClick = []
      if (item.state == 'active') {
        if (list.includes("pinchat")) {
          if (item.pin == "false") {
            this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.pinChat'), methods:'pinchat'})
          } else if (item.pin == "true") {
            this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.unpinChat'), methods:'unpinchat'})
          }
        }
        this.rightclickdialog = true
        this.$refs.menu.open($event)
        this.SelectedMessageDetail = item
      }
    },
    SelectMenuRightClick (selected) {
      // console.log(selected)
      if (selected == 'pinchat') {
        this.pin_chat()
      } else if (selected == 'unpinchat') {
        this.unpin_chat()
      }
    },
    pin_chat () {
      this.axios.post(process.env.APImanage + '/setpin', {
        tokenuser: this.token,
        tokenroom: this.SelectedMessageDetail.tokenroom,
        pin: 'true'
      }).then((response) => {
        if (response.data.status === 'success') {
          // pinchat
          var tokenroom = this.SelectedMessageDetail.tokenroom
          var index = ''
          index = _.findIndex(this.listchat, function(o) { return o.tokenroom == tokenroom })
          this.listchat[index].pin = 'true'
          var listpin = []
          var linstunpin = []
          this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
          listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
          linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
          this.listchat = _.union(listpin, linstunpin)
          // console.log(this.listchat)
        }
      }, () => {
        console.log('error')
      })
    },
    unpin_chat () {
      this.axios.post(process.env.APImanage + '/setpin', {
        tokenuser: this.token,
        tokenroom: this.SelectedMessageDetail.tokenroom,
        pin: 'false'
      }).then((response) => {
        if (response.data.status === 'success') {
          // pinchat
          var tokenroom = this.SelectedMessageDetail.tokenroom
          var index = ''
          index = _.findIndex(this.listchat, function(o) { return o.tokenroom == tokenroom })
          this.listchat[index].pin = 'false'
          var listpin = []
          var linstunpin = []
          this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
          listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
          linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
          this.listchat = _.union(listpin, linstunpin)
          // console.log(this.listchat)
        }
      }, () => {
        console.log('error')
      })
    },
    changeLangMenu () {
      this.listmenu =[
        {
          title: this.$t('HeaderMenubar.editProfile'),
          icon: 'person',
          path: 'profile'
        },
        {
          title: this.$t('HeaderMenubar.managefriend'),
          icon: 'fas fa-users',
          path: 'managefriend'
        },
        // {
        //   title: this.$t('HeaderMenubar.sendOnebox'),
        //   icon: 'file_upload',
        //   path: 'uploadfile/onebox'
        // },
        {
          title: this.$t('HeaderMenubar.feedback'),
          icon: 'feedback',
          path: 'feedback'
        },
        {
          title: this.$t('HeaderMenubar.support'),
          icon: 'contact_support',
          path: 'support'
        },
        {
          title: this.$t('HeaderMenubar.terms_of_service'),
          icon: 'book',
          path: 'terms_of_service'
        },
        {
          title: this.$t('HeaderMenubar.policy'),
          icon: 'book',
          path: 'policy'
        }
      ],
      this.listmenutask = [
        {
          title: this.$t('HeaderMenubar.calendar'),
          icon: 'fas fa-calendar-alt',
          path: 'calendar'
        },
        {
          title: this.$t('HeaderMenubar.createproject'),
          icon: 'fas fa-plus-circle',
          path: 'create_project'
        },
        {
          title: this.$t('HeaderMenubar.project'),
          icon: 'fas fa-tasks',
          path: 'all_project'
        }
      ]
    },
    secondsToHms (d) {
      d = Number(d)
      var hours = Math.floor(d / 3600)
      var minutes = Math.floor((d - (hours * 3600)) / 60)
      var seconds = d - (hours * 3600) - (minutes * 60)
      var time = ''

      if (hours !== 0) {
        time = hours + ':'
      }
      if (minutes !== 0 || time !== '') {
        minutes = (minutes < 10 && time !== '') ? '0' + minutes : String(minutes)
        time += minutes + ':'
      }
      if (time === '') {
        time = seconds + ' s'
      } else {
        time += (seconds < 10) ? '0' + seconds : String(seconds)
      }
      return time
    },
    updatelistreq (data) {
      if (data.event === 'accept') {
        this.FriendReq.splice(_.findIndex(this.FriendReq, function (o) { return o.tokenuser === data.tokenuser }), 1)
        if (_.find(this.listfriend, function (o) { return o.tokenuser === data.tokenuser }) === undefined) {
          this.listfriend.unshift({
            email: data.email,
            name: data.name,
            profilepicture: data.profilepicture,
            state: data.state,
            status: data.status,
            tokenuser: data.tokenuser,
            type: data.type,
            tokenroom: data.tokenroom
          })
          this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc'])
        }
        if (_.find(this.listchat, function (o) { return o.tokenuser === data.tokenuser }) === undefined) {
          this.listchat.unshift({
            email: data.email,
            name: data.name,
            is_active: 'true',
            profilepicture: data.profilepicture,
            state: data.state,
            status: data.status,
            tokenuser: data.tokenuser,
            type: data.type,
            tokenroom: data.tokenroom,
            nickname: '',
            timestamp: data.timestamp,
            count_read: '0'
          })
        }
      } else if (data.event === 'removeReq') {
        var index = _.findIndex(this.FriendSendReq, function (o) { return o.tokenuser === data.tokenuser })
        if (index >= 0) {
          this.FriendSendReq.splice(index, 1)
        }
      }
    },
    updatecreategroup (data, filename) {
      if (_.find(this.listgroup, function (o) { return o.group_id === data.group_id }) === undefined) {
        this.listgroup.unshift({
          count_read: '0',
          create_date: data.create_date,
          group_id: data.group_id,
          member: data.member,
          name: data.name,
          picture: filename,
          state: data.state,
          timestamp: data.timestamp,
          tokenroom: data.tokenroom,
          type: data.type
        })
        this.listgroup = _.orderBy(this.listgroup, ['name'], ['asc'])
      }
    },
    updatelistchat (data, filename) {
      // console.log(data)
      if (_.find(this.listchat, function (o) { return o.group_id === data.group_id }) === undefined) {
        this.listchat.unshift({
          is_active: 'true',
          count_read: '0',
          create_date: data.create_date,
          group_id: data.group_id,
          member: data.member,
          name: data.name,
          nickname: '',
          picture: filename,
          state: data.state,
          timestamp: data.create_date,
          tokenroom: data.tokenroom,
          type: data.type
        })
      }
    },
    getlistchat () {
      this.Progress.ListChat = true
      this.axios.post(process.env.APInew_listchat, {tokenuser: this.token}).then((response) => {
        this.Progress.ListChat = false
        if (response.data.status === 'success') {
          this.listchat = response.data['listchat']
          // console.log(this.listchat)
          // pinchat
          var listpin = []
          var linstunpin = []
          // this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true'})
          // listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
          // linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
          // this.listchat = _.union(listpin, linstunpin)
        }
      }, () => {
        this.Progress.ListChat = false
        console.log('error')
      })
    },
    getlistfriend () {
      this.Progress.ListFriend = true
      this.axios.post(process.env.APIgo_api + '/v1/get-list-friend', {tokenuser: this.token}).then((response) => {
        this.Progress.ListFriend = false
        if (response.data.status === 'success') {
          this.listfriend = response.data['list_friend']
        }
      }, () => {
        this.Progress.ListFriend = false
      })
    },
    getlistgroup () {
      this.Progress.ListGroup = true
      this.axios.post(process.env.APIgo_api + '/v1/get-list-group', {tokenuser: this.token}).then((response) => {
        this.Progress.ListGroup = false
        if (response.data.status === 'success') {
          this.listgroup = response.data['list_active_group']
        }
      }, () => {
        this.Progress.ListGroup = false
      })
    },
    showUserInGroup (item) {
      this.showgroup = item
      this.showDialog('ShowFriend')
    },
    changepathsettings (path) {
      this.pathsettings = '/chat/settings/' + path
      this.$router.push('/chat/settings/' + path)
    },
    changepathproject (path) {
      this.pathsettings = '/chat/project/' + path
      this.$router.push('/chat/project/' + path)
    },
    changebroadcast (path) {
      this.$router.push('/broadcast/' + path)
      localStorage.setItem('room', path)
    },
    changepathapi (path) {
      this.$router.push('/api/' + path)
      localStorage.setItem('room', path)
    },
    selectmenu (menu) {
      if (menu === 1) {
        this.active = 'tab-1'
        this.menu1 = 'select_Menu '
        this.menu2 = 'nonselect_Menu '
        this.menu3 = 'nonselect_Menu '
        this.menu4 = 'nonselect_Menu '
        this.menu5 = 'nonselect_Menu '
        this.menu6 = 'nonselect_Menu '
        this.menu7 = 'nonselect_Menu '
        this.menu8 = 'nonselect_Menu '
      } else if (menu === 2) {
        this.active = 'tab-2'
        this.menu1 = 'nonselect_Menu '
        this.menu2 = 'select_Menu '
        this.menu3 = 'nonselect_Menu '
        this.menu4 = 'nonselect_Menu '
        this.menu5 = 'nonselect_Menu '
        this.menu6 = 'nonselect_Menu '
        this.menu7 = 'nonselect_Menu '
        this.menu8 = 'nonselect_Menu '
      } else if (menu === 3) {
        this.active = 'tab-3'
        this.menu1 = 'nonselect_Menu '
        this.menu2 = 'nonselect_Menu '
        this.menu3 = 'select_Menu '
        this.menu4 = 'nonselect_Menu '
        this.menu5 = 'nonselect_Menu '
        this.menu6 = 'nonselect_Menu '
        this.menu7 = 'nonselect_Menu '
        this.menu8 = 'nonselect_Menu '
      } else if (menu === 4) {
        this.active = 'tab-4'
        this.menu1 = 'nonselect_Menu '
        this.menu2 = 'nonselect_Menu '
        this.menu3 = 'nonselect_Menu '
        this.menu4 = 'select_Menu '
        this.menu5 = 'nonselect_Menu '
        this.menu6 = 'nonselect_Menu '
        this.menu7 = 'nonselect_Menu '
        this.menu8 = 'nonselect_Menu '
      } else if (menu === 5) {
        this.active = 'tab-5'
        this.menu1 = 'nonselect_Menu '
        this.menu2 = 'nonselect_Menu '
        this.menu3 = 'nonselect_Menu '
        this.menu4 = 'nonselect_Menu '
        this.menu5 = 'select_Menu '
        this.menu6 = 'nonselect_Menu '
        this.menu7 = 'nonselect_Menu '
        this.menu8 = 'nonselect_Menu '
      } else if (menu === 6) {
        this.active = 'tab-6'
        this.menu1 = 'nonselect_Menu '
        this.menu2 = 'nonselect_Menu '
        this.menu3 = 'nonselect_Menu '
        this.menu4 = 'nonselect_Menu '
        this.menu5 = 'nonselect_Menu '
        this.menu6 = 'select_Menu '
        this.menu7 = 'nonselect_Menu '
        this.menu8 = 'nonselect_Menu '
      } else if (menu === 7) {
        this.active = 'tab-7'
        this.menu1 = 'nonselect_Menu '
        this.menu2 = 'nonselect_Menu '
        this.menu3 = 'nonselect_Menu '
        this.menu4 = 'nonselect_Menu '
        this.menu5 = 'nonselect_Menu '
        this.menu6 = 'nonselect_Menu '
        this.menu7 = 'select_Menu '
        this.menu8 = 'nonselect_Menu '
      } else if (menu === 8) {
        this.active = 'tab-8'
        this.menu1 = 'nonselect_Menu '
        this.menu2 = 'nonselect_Menu '
        this.menu3 = 'nonselect_Menu '
        this.menu4 = 'nonselect_Menu '
        this.menu5 = 'nonselect_Menu '
        this.menu6 = 'nonselect_Menu '
        this.menu7 = 'nonselect_Menu '
        this.menu8 = 'select_Menu '
        console.log(`active: ${this.active}`)
        // this.toPageOnemeet('/onemeeting', 'onemeet')
      }
      // เซตค่าเวลาที่สลับ layout
      // this.$router.push('/chat')
      if (this.active !== 'tab-8') {
        this.$router.push('/chat')
      }
      localStorage.setItem('menu_left', JSON.stringify({
        'active': this.active,
        'menu1': this.menu1,
        'menu2': this.menu2,
        'menu3': this.menu3,
        'menu4': this.menu4,
        'menu5': this.menu5,
        'menu6': this.menu6,
        'menu7': this.menu7,
        'menu8': this.menu8
      }))
    },
    RemoveReq_FriendSendReq (item) {
      this.axios.post(process.env.APImanage + '/removerequestfriend', {tokenfriend: item.tokenuser, tokenuser: this.token}).then((response) => {
        if (response.data.status === 'success') {
          this.FriendSendReq.splice(_.findIndex(this.FriendSendReq, function (o) { return o.tokenuser === item.tokenuser }), 1)
        }
      })
    },
    AcceptReq_GroupReq (group) {
      this.axios.post(process.env.APImanage + '/activeinvitegroup', {group_id: group.group_id, tokenuser: this.token}).then((response) => {
        if (response.data.status === 'success') {
          var tokenuser = this.token
          var indexgroup = _.findIndex(response.data.group.member, function (o) { return o.tokenuser === tokenuser })
          if (indexgroup >= 0) {
            this.socketactive_group = {timestamp: response.data.group.member[indexgroup].timestamp_in, groupid: group.group_id, tokenuser: this.token}
          } else {
            this.socketactive_group = {timestamp: '', groupid: group.group_id, tokenuser: this.token}
          }
        }
      })
    },
    RemoveReq_GroupReq (group) {
      // console.log(group)
      this.$swal({
        title: 'คุณแน่ใจหรือไหม?',
        text: 'คุณกำลังยกเลิกคำเชิญเข้ากลุ่ม ' + group.name + ' !',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ใช่, ฉันต้องยกเลิกคำเชิญ!',
        cancelButtonText: 'ไม่ใช่, ยกเลิก!',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APImanage + '/cancelinvitegroup', {group_id: group.group_id, tokenuser: this.token}).then((response) => {
            if (response.data.status === 'success') {
              // this.GroupReq.splice(this.GroupReq.indexOf(group), 1) // ลบ GroupReq ตอนยกเลิกเข้ากลุ่ม
            }
          })
        }
      })
    },
    AcceptReq_FriendReq (Friend) {
      this.axios.post(process.env.APInew_acceptfriend, {tokenfriend: Friend.tokenuser, tokenuser: this.token}).then((response) => {
        if (response.data.status === 'success') {
          var index = _.findIndex(this.FriendReq, function (o) { return o.tokenuser === Friend.tokenuser })
          if (index >= 0) {
            this.FriendReq.splice(index, 1)
          }
          this.$router.push('/chat/room/' + response.data.tokenroom)
          var data = response.data.source
          data['tokenroom'] = response.data.tokenroom
        } else {
        }
      })
    },
    RemoveReq_FriendReq (Friend) {
      this.$swal({
        title: 'คุณแน่ใจหรือไหม?',
        text: 'คุณกำลังยกเลิกคำเชิญ ' + Friend.name + ' !',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ใช่, ฉันต้องยกเลิกคำเชิญ!',
        cancelButtonText: 'ไม่ใช่, ยกเลิก!',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          // if (Friend.type === 'user') {
          this.axios.post(process.env.APImanage + '/removerequestfriend', {tokenfriend: Friend.tokenuser, tokenuser: this.token}).then((response) => {
            if (response.data['status'] === 'success') {
              this.socketremove_request_friend = {
                tokenuser: Friend.tokenuser,
                tokenfriend: this.token
              }
            } else {
            }
          })
        }
      })
    },
    lengthactive (member) {
      return _.filter(member, function (member) { return member.statemember === 'active' }).length
    },
    showDialog (dialog) {
      if (dialog === 'AddFriend') {
        this.AddFriend = true
      } else if (dialog === 'CreateGroup') {
        this.CreateGroup = true
      } else if (dialog === 'ShowFriend') {
        this.ShowFriend = true
      }
    },
    closeDialogShowFriend (value) {
      this.ShowFriend = value
    },
    closeDialogAddFriend (value) {
      this.AddFriend = value
    },
    closeDialogCreateGroup (value) {
      this.CreateGroup = value
    },
    time (timestamp) {
      return (this.$i18n.locale == 'th')? Momenttime.momenttimethaiformnow(timestamp): Momenttime.momenttimethaiformnowen(timestamp)
    },
    routeChat (data) {
      // console.log(data)
      // this.$cookie.set('typeuser_friend', data.type)
      // this.$cookie.set('tokenuser_friend', Encode.encodeToken(data.tokenuser))
      this.actionF = data.tokenroom
      // check consent
      if (data.type === 'bot') {
        this.getConsent(data.tokenuser, data.tokenroom)
      } else {
        this.$router.push('/chat/room/' + data.tokenroom)
      }
      // this.$router.push('/chat/room/' + data.tokenroom)
      var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
      if (this.listchat[indexmsg].is_active == 'true'){
        this.notread = this.notread - this.listchat[indexmsg].count_read
      }
      this.listchat[indexmsg].is_active = 'true'

      this.listchat[indexmsg].count_read = 0

      this.mark_read(data)
      this.pathsettings = '/chat/room/' + data.tokenroom
    },
    getConsent (botid, tokenroom) {
      this.axios.post(process.env.APIalpine + '/api/v1/get-consent-bot', {
        tokenuser: this.token,
        bot_id: botid
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          if (response.data.isConsent === true && response.data.isAccept === false) {
            var dataConsent = Encode.encode(response.data.data)
            this.$router.push('/check-consent/' + tokenroom + `/?data_consent=${dataConsent}`)
          } else {
            this.$router.push('/chat/room/' + tokenroom)
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    mark_read (data) {
      // console.log('mark_read')
      if (data.count_read !== '0' && data.count_read !== '') {
        this.axios.post(process.env.APIalpine + '/api/v1/user-mark-read', {tokenuser: this.token, tokenroom: data.tokenroom}).then((response) => {
        })
      }
    },
    blockevent (data) {
      if (data.event === 'block_friend') {
        var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenuser === data.tokenuser })
        var indexchat = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
        if (indexchat != -1) {
          this.listchat[indexchat]['timestamp'] = data.timestamp
          this.listchat[indexchat]['state'] = 'block'
          // this.listchat = _.orderBy(this.listchat, ['timestamp'], ['asc']).reverse()
          this.axios.post(process.env.APImanage + '/setpin', {tokenroom: data.tokenroom, tokenuser: this.token, pin: 'false'}).then((response) => {
            var listpin = []
            var linstunpin = []
            this.listchat[indexchat].pin = 'false'
            this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
            listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
            linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
            this.listchat = _.union(listpin, linstunpin)
          })
        }
        indexmsg = _.findIndex(this.listfriend, function (o) { return o.tokenuser === data.tokenuser })
        if (indexmsg != -1) {
          _.pullAt(this.listfriend, indexmsg)
        }
      } else if (data.event === 'unblock_friend') {
        this.listfriend.push(data)
        this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc'])
        indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
        if (indexmsg != -1) {
          this.listchat[indexmsg].state = 'active'
          this.listchat[indexmsg].nickname = ''
        }
      }
    }
  },
  computed: {
    // count_read () {
    //   if (this.notread == 0) {
    //     return 'OneChat'
    //   } else {
    //     return '(' + this.notread + ') Onechat'
    //   }
    // },
    FilterFriendList () {
      if (this.search !== '' && this.search !== null) {
        return this.listfriend.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listfriend
      }
    },
    FilterGroupList () {
      if (this.search !== '' && this.search !== null) {
        return this.listgroup.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listgroup
      }
    },
    FilterChatList () {
      if (this.search !== '' && this.search !== null) {
        return this.listchat.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listchat
      }
    },
    ...sync('*')
  },
  watch: {
    GroupReq () {
      this.num_groupreq = this.GroupReq.length
    },
    FriendReq () {
      this.num_friendreq = this.FriendReq.length
    },
    chIsactive (data) {
      this.axios.post(process.env.APImanage + '/setisactive', {tokenroom: data, tokenuser: this.token, is_active: 'false'}).then((response) => {
        if (response.data.status === 'success') {
          var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === data })
          this.listchat[indexmsg].is_active = false
          this.$router.push('/chat/homepage')
          this.axios.post(process.env.APImanage + '/setpin', {tokenroom: data, tokenuser: this.token, pin: 'false'}).then((response) => {
            var listpin = []
            var linstunpin = []
            this.listchat[indexmsg].pin = 'false'
            this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
            listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
            linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
            this.listchat = _.union(listpin, linstunpin)
          })
        }
      })
    },
    block_friend (data) {
      this.blockevent(data)
    },
    socket_unsendmessage (data) {
      // console.log(data)
      this.axios.post(process.env.APIpub + '/getmessage', {tokenmessage: data.last_tokenmessage._id, tokenuser: this.token}).then((response) => {
        // console.log(response.data.source)
        var dataunsend = {}
        dataunsend = response.data.source
        var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
        if (indexmsg !== -1) {
          this.listchat[indexmsg].is_active = 'true'
          // var message = dataunsend.message
          // if (data.tokenroom !== this.actionF) {
          //   this.listchat[indexmsg].count_read = parseInt(this.listchat[indexmsg].count_read) + 1
          // }
          this.listchat[indexmsg].message = dataunsend.message
          this.listchat[indexmsg].timestamp = dataunsend.timestamp
          this.listchat[indexmsg].nickname = dataunsend.nickname
          this.listchat[indexmsg].typeofmessage = dataunsend.typeofmessage
          this.listchat[indexmsg].time_count = dataunsend.time_count
          this.listchat[indexmsg].file_name = dataunsend.file_name
          this.listchat[indexmsg].tokenuser = dataunsend.tokenuser
          var listpin = []
          var linstunpin = []
          var pin = _.partition(this.listchat, function(o) { return o.pin == 'true' })
          listpin = _.orderBy(pin[0], 'timestamp', 'desc')
          linstunpin = _.orderBy(pin[1], 'timestamp', 'desc')
          this.listchat = _.union(listpin, linstunpin)
          // if (indexmsg === 0) {
          //   this.listchat[indexmsg].message = dataunsend.message
          //   this.listchat[indexmsg].timestamp = dataunsend.timestamp
          //   this.listchat[indexmsg].nickname = dataunsend.nickname
          //   this.listchat[indexmsg].typeofmessage = dataunsend.typeofmessage
          //   this.listchat[indexmsg].time_count = dataunsend.time_count
          //   this.listchat[indexmsg].file_name = dataunsend.file_name
          //   this.listchat[indexmsg].tokenuser = dataunsend.tokenuser
          // } else {
          //   var dataindex = this.listchat[indexmsg]
          //   dataindex.message = dataunsend.message
          //   dataindex.timestamp = dataunsend.timestamp
          //   dataindex.nickname = dataunsend.nickname
          //   dataindex.typeofmessage = dataunsend.typeofmessage
          //   dataindex.time_count = dataunsend.time_count
          //   dataindex.file_name = dataunsend.file_name
          //   dataindex.tokenuser = dataunsend.tokenuser
          //   _.pullAt(this.listchat, indexmsg) // ลบ listchat เดิม
          //   this.listchat.unshift(dataindex) // เพิ่ม lischat ใหม่เข้าไป
          // }
        }
      })
    },
    socketmessage (data) {
      // console.log(data)
      // console.log(this.listchat)
      if (data.typeofmessage !== "system_action") {
        var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
        if (indexmsg !== -1) {
          this.listchat[indexmsg].is_active = 'true'
          var message = data.message
          // if (data.typeofmessage !== 'message') {
          //   message = 'Send ' + data.message
          // }
          if (data.tokenroom !== this.actionF && data.tokenuser != this.token) {
            this.listchat[indexmsg].count_read = parseInt(this.listchat[indexmsg].count_read) + 1
            this.notread = this.notread + 1
          } else if (data.tokenuser == this.token) {
            this.notread = this.notread - parseInt(this.listchat[indexmsg].count_read)
            this.listchat[indexmsg].count_read = 0
          }
          if (indexmsg === 0) {
            this.listchat[0].message = message
            this.listchat[0].timestamp = data.timestamp
            this.listchat[0].nickname = data.nickname
            this.listchat[0].typeofmessage = data.typeofmessage
            this.listchat[0].time_count = data.time_count
            this.listchat[0].file_name = data.file_name
            this.listchat[0].tokenuser = data.tokenuser
          } else {
            var dataindex = this.listchat[indexmsg]
            dataindex.message = message
            dataindex.timestamp = data.timestamp
            dataindex.nickname = data.nickname
            dataindex.typeofmessage = data.typeofmessage
            dataindex.time_count = data.time_count
            dataindex.file_name = data.file_name
            dataindex.tokenuser = data.tokenuser
            _.pullAt(this.listchat, indexmsg) // ลบ listchat เดิม
            this.listchat.unshift(dataindex) // เพิ่ม lischat ใหม่เข้าไป
          }
        }
        // เรียงแชทใหม่ กรณที่มีการ pin
        var listpin = []
        var linstunpin = []
        this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
        listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
        linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
        this.listchat = _.union(listpin, linstunpin)
        // console.log(this.listchat)
      }
    },
    socketleave_group (data) {
      // console.log(data)
      var self = this
      data.listkick.forEach(function (item) {
        if (item === self.token) {
          var index = _.findIndex(self.listgroup, function (o) { return o.tokenroom === data.tokenroom })
          if (index >= 0) {
            self.listgroup.splice(index, 1)
          }
          var indexchat = _.findIndex(self.listchat, function (o) { return o.tokenroom === data.tokenroom })
          if (indexchat >= 0) {
            self.listchat[indexchat].state = 'leave'
            self.axios.post(process.env.APImanage + '/setpin', {tokenroom: data.tokenroom, tokenuser: self.token, pin: 'false'}).then((response) => {
              var listpin = []
              var linstunpin = []
              self.listchat[indexchat].pin = 'false'
              self.listchat = _.partition(self.listchat, function(o) { return o.pin == 'true' })
              listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
              linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
              self.listchat = _.union(listpin, linstunpin)
            })
          }
        }
      })
    },
    socket_kickmember (data) {
      var self = this
      data.listkick.forEach(function (item) {
        if (item === self.token) {
          var index = _.findIndex(self.listgroup, function (o) { return o.tokenroom === data.tokenroom })
          if (index >= 0) {
            self.listgroup.splice(index, 1)
          }
          var indexchat = _.findIndex(self.listchat, function (o) { return o.tokenroom === data.tokenroom })
          if (indexchat >= 0) {
            self.listchat[indexchat].state = 'leave'
          }
        }
      })
    },
    socketactive_group (data) {
      // console.log(data)
      this.axios.post(process.env.APImanage + '/getgroup', {group_id: data.groupid, tokenuser: this.token}).then((response) => {
        // console.log(response.data)
        var indexgroup = _.findIndex(this.GroupReq, function (o) { return o.group_id === response.data.group.group_id }) // หาตำแหน่งของ group req ที่ต้องการจะลบ
        if (indexgroup >= 0) {
          _.pullAt(this.GroupReq, indexgroup) // ลบ GroupReq เดิม
          this.num_groupreq = this.GroupReq.length // จำนวน group req
        }
        // update listgroup
        if (_.find(this.listgroup, function (o) { return o.group_id === response.data.group.group_id }) === undefined) {
          // console.log('有group')
          var group = response.data.group
          group.timestamp = data.timestamp
          this.listgroup.unshift(group)
          this.listgroup = _.orderBy(this.listgroup, ['name'], ['asc'])
          this.getlistchat()
        }
        // update listchat
        // console.log(this.listchat)
        // if (_.find(this.listchat, function (o) { return o.group_id === response.data.group.group_id }) === undefined) {
        //   console.log(response.data.group)
        //   var chat = response.data.group
        //   chat.timestamp = data.timestamp
        //   chat.count_read = ''
        //   chat.nickname = ''
        //   chat.is_active = 'true'
        //   this.listchat.unshift(chat)
        //   console.log(this.listchat.unshift(chat))
        // }
        if (data.tokenuser === this.token) {
          var indexchat = _.findIndex(this.listchat, function (o) { return o.group_id === response.data.group.group_id }) // หาตำแหน่งของ group req ที่ต้องการจะลบ
          // console.log(indexchat)
          if (indexchat != -1) {
            this.listchat[indexchat].state = 'active'
          }
          // this.listchat[indexchat].state = 'active'
        }
      })
    },
    socketcencel_group (data) {
      // console.log(data)
      if (this.GroupReq.length !== 0) {
        // ลบ group req
        var index = _.findIndex(this.GroupReq, function (o) { return o.group_id === data.group_id })
        if (index >= 0) {
          this.GroupReq.splice(index, 1)
        }
      }
    },
    socketremove_friend (data) {
      // console.log(data)
      var index = _.findIndex(this.listfriend, function (o) { return o.tokenroom === data.tokenroom })
      if (index >= 0) {
        this.listfriend.splice(index, 1)
      }
      var indexchat = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
      if (indexchat >= 0) {
        this.listchat[indexchat].state = 'unfriend'
      }
    },
    socketremove_request_friend (data) {
      var indexReq = _.findIndex(this.FriendReq, function (o) { return o.tokenuser === data.tokenuser })
      var indexSendReq = _.findIndex(this.FriendSendReq, function (o) { return o.tokenuser === data.tokenuser })
      if (indexReq >= 0) {
        this.FriendReq.splice(indexReq, 1)
      }
      if (indexSendReq >= 0) {
        this.FriendSendReq.splice(indexSendReq, 1)
      }
    },
    socketaccept_friend (data) {
      // console.log(data)
      var tokenfriend = data.tokenfriend
      if (this.token === data.tokenfriend) {
        tokenfriend = data.tokenuser
        var indexSendReq = _.findIndex(this.FriendSendReq, function (o) { return o.tokenuser === data.tokenuser })
        if (indexSendReq >= 0) {
          this.FriendSendReq.splice(indexSendReq, 1)
        }
      } else {
        var indexReq = _.findIndex(this.FriendReq, function (o) { return o.tokenuser === data.tokenfriend })
        if (indexReq >= 0) {
          this.FriendReq.splice(indexReq, 1)
        }
      }
      this.axios.post(process.env.APImanage + '/searchtokenuser', {tokenuser: this.token, tokenfriend: tokenfriend}).then((response) => {
        if (_.find(this.listfriend, function (o) { return o.tokenuser === response.data.user.tokenuser }) === undefined) {
          this.listfriend.unshift(response.data.user)
          // this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc'])
        }
        // update listchat
        var indexchat = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
        var json = response.data.user
        json.nickname = ''
        json.picture = response.data.user.profilepicture
        json.state = 'user'
        json.timestamp = data.timestamp
        json.count_read = '0'
        json.is_active = 'true'
        // console.log(json)
        if (indexchat >= 0) {
          this.listchat.splice(indexchat, 1)
          this.listchat.unshift(json)
        } else {
          this.listchat.unshift(json)
        }
        // เรียงแชทใหม่ กรณที่มีการ pin
        var listpin = []
        var linstunpin = []
        this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
        listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
        linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
        this.listchat = _.union(listpin, linstunpin)
      })
    },
    socketfriend (data) {
      // console.log(data)
      // console.log(process.env.APImanage + '/searchtokenuser', {tokenuser: this.token, tokenfriend: data.tokenfriend})
      this.axios.post(process.env.APImanage + '/searchtokenuser', {tokenuser: this.token, tokenfriend: data.tokenfriend[0]}).then((response) => {
        // var _ = require('lodash')
        if (data.konAdd !== this.token) {
          // update Friend request
          if (_.find(this.FriendReq, function (o) { return o.tokenuser === response.data.user.tokenuser }) === undefined) {
            this.FriendReq.unshift(response.data.user)
            this.FriendReq = _.orderBy(this.FriendReq, ['name'], ['asc']).reverse()
          }
        } else {
          if (_.find(this.FriendSendReq, function (o) { return o.tokenuser === response.data.user.tokenuser }) === undefined) {
            this.FriendSendReq.unshift(response.data.user)
            this.FriendSendReq = _.orderBy(this.FriendSendReq, ['name'], ['asc']).reverse()
          }
        }
      })
    },
    socketinvite_group (data) {
      // console.log(data)
      var index = _.findIndex(this.listgroup, function (o) { return o.tokenroom === data.tokenroom })
      if (index < 0) {
        this.axios.post(process.env.APImanage + '/getgroup', {group_id: data.groupid, tokenuser: data.userinvited}).then((response) => {
          // console.log(response.data.group)
          this.GroupReq.unshift(response.data.group)
          this.GroupReq = _.orderBy(this.GroupReq, ['create_date'], ['asc'])
        })
      }
    },
    socketcreate_group (data) {
      if (data.fromtokenuser !== this.token) {
        if (_.find(this.GroupReq, function (o) { return o.group_id === data.groupid }) === undefined) {
          this.axios.post(process.env.APImanage + '/getgroup', {group_id: data.groupid, tokenuser: data.fromtokenuser}).then((response) => {
            this.GroupReq.unshift(response.data.group)
            this.GroupReq = _.orderBy(this.GroupReq, ['create_date'], ['asc'])
          })
        }
      }
    },
    '$route.params.roomid' () {
      this.actionF = this.$route.params.roomid
    },
    '$i18n.locale' () {
      this.changeLangMenu()
    }
  }
}
</script>
<style type="text/css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
>>>.v-list {
  max-width: 100% !important;
}
>>>.v-badge__badge {
  /* margin-top: 10px !important;
  margin-right: 10px !important; */
  color: #fff;
    display: flex;
    position: absolute;
    font-size: 14px;
    top: -7px;
    right: -14px;
    border-radius: 50%;
    height: 20px;
    width: 20px;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    transition: .3s cubic-bezier(.25,.8,.5,1);
}
.img-pin {
  width: 16px !important;
  height: 16px !important;
  /* margin-top: 15px !important; */
  position: absolute !important;
  z-index: 2 !important;
  /* margin-left: 19px !important; */
}
>>>.theme--light.v-expansion-panel .v-expansion-panel__container .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon {
    color: rgb(253, 253, 253) !important;
}
>>>.v-text-field .v-label {
    max-width: 100% !important;
}
>>>.v-badge {
    margin-top: 11px !important;
}
.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #1a75d2 !important;
  color: white !important;
  text-transform: none;
}
.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #242b36 !important;
  color: white !important;
  text-transform: none;
}
.input-group--text-field input {
  color: white !important;
}
.tabs{
  background-color: #27303e !important;
}

.layoutsearchweb {
  background-color: #1b232d !important;
  color: white !important;
  padding: 2px;
}
.bgsearchweb {
  background-color: #232a35 !important;
  color: white !important;
  border-radius: 100px !important;
  font-size: 12px !important;
  margin-top: 2vh !important;
  margin-bottom: 2vh !important;
}
>>> .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: rgba(255, 255, 255, 0.87);
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
    box-shadow: none;
    background: #232a35 !important;
    border-radius: 100px !important;
    font-size: 12px !important;
}
>>> .v-text-field.v-text-field--enclosed .v-text-field__details {
     margin-bottom: 0px;
}
>>> .bgsearchweb label {
  color: #b9b7b7 !important;
}
>>> .input-group__input input {
  color: white !important;
}
>>> .theme--light.v-icon {
    color: rgba(255, 255, 255, 0.54);
}

.leftbox{
  height: 91vh;
  background-color: #1b232d !important;
  overflow: hidden;
}
.fontselect{
  color:#53CEFF !important;
  font-family: 'CS ChatThaiUI' !important;
  font-size:13px;
}
.nonfontselect{
  color: white !important;
  font-family: 'CS ChatThaiUI' !important;
  font-size:13px;
}
.fontselectchat{
  color: #bdbdbd !important;
  font-family: 'CS ChatThaiUI' !important;
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
  word-wrap: break-word;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.selectF{
  background-color: #27303e !important;
  width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  font-family: 'CS ChatThaiUI' !important;
}
.nonselectF{
  background-color: #1b232d !important;
  width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  font-family: 'CS ChatThaiUI' !important;
}
.headerlist {
  color:white !important;
  font-weight: 700;
}
.tabs__item--active {
    opacity: 1;
    color: #53ceff!important;
}
.btn--floating {
    height: 23px !important;
    width: 23px !important;
  }
.cardlist{
    padding-top: 10px;
    width: 100%;
    height: 30vh;
    overflow-x: hidden;
    overflow-y: scroll;
}

.cardlist::-webkit-scrollbar{
    width: 10px;
}

.cardlist::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background: rgba(0, 0, 0, .1);
}
.list__tile .list__tile--link .list__tile--avatar{
  padding: 0px !important;
}
.list .list--three-line {
  background-color: #1b232d !important;
}
.list .list--dense {
  background-color: #1b232d !important;
}
.tabs__container{
  justify-content: center !important;
}
.material-icons .icon .icon--right {
  display: none;
}
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
.fixed-content {
    min-height:100%;
    overflow-y:scroll;
    overflow-x:hidden;
}
.application .theme--light.input-group:not(.input-group--error) label, .theme--light .input-group:not(.input-group--error) label {
    color: rgba(0,0,0,.54);
    padding-left: 0 !important;
    padding-right: 0 !important;
}


.application .theme--light.list .list__tile:not(.list__tile--active), .theme--light .list .list__tile:not(.list__tile--active) {
   padding: 0 !important;
}

>>> .nonselect_Menu{
  color:rgb(119, 119, 119) !important;
  background-color: #1b232d !important;
  padding: 0px !important;
}
>>> .select_Menu {
  color:white !important;
  background-color: #27303e !important;
  padding: 0px !important;
}

.application .theme--light.expansion-panel .expansion-panel__container .expansion-panel__header .icon, .theme--light .expansion-panel .expansion-panel__container .expansion-panel__header .icon {
    color: white;
}
.application .theme--light.input-group:not(.input-group--error) label, .theme--light .input-group:not(.input-group--error) label {
    color: #f5f5f5 !important;
    font-size: 16px;
    padding-left: 0;
}

.application .theme--light.input-group:not(.input-group--error):not(.input-group--focused):not(.input-group--disabled) .input-group__input .input-group__append-icon:not(:hover), .application .theme--light.input-group:not(.input-group--error):not(.input-group--focused):not(.input-group--disabled) .input-group__input .input-group__prepend-icon:not(:hover), .theme--light .input-group:not(.input-group--error):not(.input-group--focused):not(.input-group--disabled) .input-group__input .input-group__append-icon:not(:hover), .theme--light .input-group:not(.input-group--error):not(.input-group--focused):not(.input-group--disabled) .input-group__input .input-group__prepend-icon:not(:hover) {
    color: #ffffff52 !important;
}

.expansion_container {
  width: 100%;
  background: #232a35 !important;
  color: white !important;
}
>>>.v-tabs__container {
  display: none !important;
}
>>> .v-list__tile {
  padding: 0 !important;
}

>>>.v-badge--overlap .v-badge__badge  {
  top: 10px !important;
  right: -10px !important;
  display: inline-grid !important;
}

>>>.v-list__tile__sub-title, .v-list__tile__title {
  text-overflow: unset;
}
/*.user-search-block > input {
  background-image: url(../assets/image/logo6.png);
  background-repeat: no-repeat;
}
*/

</style>



// WEBPACK FOOTER //
// src/components/chat/onemeet/LefttestOnemeet.vue